// extracted by mini-css-extract-plugin
export default {"description":"secondary-action__description"};